import { SectorsLayout } from "@design-system/layouts";
import { Outlet, useLoaderData } from "@remix-run/react";

export default function SectorsLayoutRoute() {
  useLoaderData();

  return (
    <SectorsLayout>
      <Outlet />
    </SectorsLayout>
  );
}
